/** Popper margin (8) + border (1) above every dropdown's content. */
const DROPDOWN_CHROME_PX = 9;

/**
 * Measured padding above each editor's first line of text. Each pads its own
 * header differently, so one offset can't serve both.
 */
const EDITOR_TEXT_INSET_PX = {
  /** Dropdowns opening on a search box (multiselect, single-select list). */
  searchHeader: 2,
  /** Dropdowns opening straight onto a selectable row (boolean, exists, date). */
  listRow: 6,
};

export type CascadeSubmenuEditor = keyof typeof EDITOR_TEXT_INSET_PX;

/**
 * Popper `offsetY` that sits a cascade submenu's first line of text on the text
 * of the parent row that opened it.
 */
export function cascadeSubmenuOffsetY(editor: CascadeSubmenuEditor): number {
  return -(DROPDOWN_CHROME_PX + EDITOR_TEXT_INSET_PX[editor]);
}
